export default {
  title: 'Cart',
  buttons: {
    login_to_checkout: 'Login to checkout',
    checkout: 'Checkout',
  },
  go_to_menu: 'Go to menu',
  toasts: {
    cashback_points_removed: 'Your points balance has changed, so we removed the points from this order.',
  },
};
